const information = [
  {
    name: "Контакты",
    link: "/contacts",
  },
  {
    name: "Доставка",
    link: "/content/delivery-and-payment",
  },
  {
    name: "Оплата",
    link: "/content/delivery-and-payment",
  },
  {
    name: "О нас",
    link: "/content/about",
  },

  {
    name: "Акции",
    link: "/content/promotions",
  },
];

export const policy = [
  {
    name: "Cookies",
    link: "/cookies-policy",
  },
  {
    name: "Политика пользовательских данных",
    link: "/privacy-policy",
  },
  {
    name: "Согласие на обработку персональных данных",
    link: "/confidential",
  },
];

export default information;
